module.exports = __webpack_public_path__ + "img/photo.a75f9fa1.png";